import '../styles.scss'
import React from 'react'

import { Selector } from 'components/SmartChatView/Fields'

const OneShotProductViewUI = ({ renderType, label, placeholder, processesOptions, value, onChangeInner, loadingProcessesOptions, error, previewIntegrity }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <>
        <Selector
          isRequired
          label={label.productFoundProcess}
          placeholder={placeholder.productFoundProcess}
          options={processesOptions || []}
          value={value.productFoundProcess}
          onChange={value => onChangeInner({ fieldType: 'productFoundProcess', fieldData: value })}
          loading={loadingProcessesOptions}
          error={error?.productFoundProcess}
        />
        <Selector
          isRequired
          label={label.productNotFoundProcess}
          placeholder={placeholder.productNotFoundProcess}
          options={processesOptions || []}
          value={value.productNotFoundProcess}
          onChange={value => onChangeInner({ fieldType: 'productNotFoundProcess', fieldData: value })}
          loading={loadingProcessesOptions}
          error={error?.productNotFoundProcess}
        />
      </>
    )}
    {renderType === 'preview' && (
      <div className='action-view__process-search-preview'>
        <Selector
          placeholder={placeholder.productFoundProcess}
          options={processesOptions || []}
          value={value.productFoundProcess}
          onChange={value => onChangeInner({ fieldType: 'productFoundProcess', fieldData: value })}
          loading={loadingProcessesOptions}
          error={previewIntegrity.productFoundProcess}
        />
        <Selector
          placeholder={placeholder.productNotFoundProcess}
          options={processesOptions || []}
          value={value.productNotFoundProcess}
          onChange={value => onChangeInner({ fieldType: 'productNotFoundProcess', fieldData: value })}
          loading={loadingProcessesOptions}
          error={previewIntegrity.productNotFoundProcess}
        />
      </div>
    )}
  </div>
)

export default OneShotProductViewUI
